(() => {
  angular.module('app').controller('host.views.forms.page', FormsPageController);

  FormsPageController.$inject = [
    'abp.services.app.formTemplate',
    'Hms.FormTemplates.FormNames',
    'Hms.Services.ServiceType',
    'Hms.FormTemplates.TargetUserType',
    'appConstants'
  ];

  function FormsPageController(
    formTemplateSvc,
    enumFormNames,
    enumServiceType,
    enumTargetUserType,
    appConstants
  ) {
    const vm = this;

    vm.loading = 0;
    vm.formNames = [];

    vm.enums = {};
    vm.enums.formNames = enumFormNames;
    vm.enums.serviceType = enumServiceType;
    vm.enums.targetUserType = enumTargetUserType;

    vm.check = true;
    vm.gridOptions = {
      appScopeProvider: vm,
      paginationPageSizes: appConstants.grid.defaultPageSize,
      paginationPageSize: appConstants.grid.defaultPageSize,
      paginationCurrentPage: 1,
      useExternalPagination: true,
      useExternalSorting: true,
      resizable: true,
      columnDefs: [
        {
          name: 'Actions',
          displayName: 'Actions',
          enableSorting: false,
          width: 100,
          headerCellTemplate: '<span></span>',
          allowCellFocus: false,
          cellTemplate: 'actionForm',
        },
        {
          displayName: App.localize('Name'),
          field: 'name',
          minWidth: 120,
          cellTemplate: 'nameTemplate',
        },
        {
          displayName: App.localize('Country'),
          field: 'countryCode',
          minWidth: 50,
          visible: vm.hasRegionalSystemSupport,
          cellTemplate: 'countryCodeTemplate',
        },
        {
          displayName: App.localize('ServiceType'),
          field: 'serviceType',
          minWidth: 150,
          cellTemplate: 'serviceTypeTemplate',
        },
        {
          displayName: App.localize('UserType'),
          field: 'targetUserType',
          minWidth: 120,
          cellTemplate: 'userTypeTemplate',
        },
        {
          displayName: App.localize('Status'),
          field: 'isActive',
          minWidth: 120,
          cellTemplate: 'statusTemplate',
        },
        {
          displayName: App.localize('LastUpdated'),
          field: 'lastModificationTime',
          cellFilter: "momentFormat: 'L LT'",
          minWidth: 120,
        },
      ],
      data: [],
      totalItems: 0,
      onRegisterApi(gridApi) {
        vm.gridApi = gridApi;
        gridApi.pagination.on.paginationChanged(null, (newPage, pageSize) => {
          vm.gridOptions.paginationCurrentPage = newPage;
          vm.gridOptions.paginationPageSize = pageSize;
          getAllFormTemplates();
        });
        gridApi.core.on.sortChanged(null, (grid, sortColumns) => {
          vm.sort = sortColumns.length ? sortColumns[0] : null;
          getAllFormTemplates();
        });
      }
    };

    vm.deleteForm = deleteForm;

    init();

    function init() {
      getAllFormTemplates();
      getAllFormNames();
    }

    function getAllFormTemplates() {
      vm.loading += 1;
      // Calculate skipCount and maxResultCount for server-side paging
      const page = vm.gridOptions.paginationCurrentPage || 1;
      const pageSize = vm.gridOptions.paginationPageSize || appConstants.grid.defaultPageSize;
      const skipCount = (page - 1) * pageSize;
      const maxResultCount = pageSize;

      // Sorting
      let sorting = null;
      if (vm.sort && vm.sort.field) {
        sorting = `${vm.sort.field  } ${  vm.sort.sort.direction || 'asc'}`;
      }

      formTemplateSvc
        .getAllFormTemplate({
          skipCount,
          maxResultCount,
          sorting
        })
        .success((data) => {
          vm.gridOptions.data = data.items;
          vm.gridOptions.totalItems = data.totalCount || 0;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function getAllFormNames() {
      formTemplateSvc.getAllFormNames({}).success((data) => {
        vm.formNames = data.items;
      });
    }

    function getDisplayFormName(formNameEnum) {
      const form = _.find(vm.formNames, ['value', formNameEnum]);
      return form.name;
    }

    function deleteForm(form) {
      abp.message.confirm(
        App.localize('FormDeleteWarningMessage', getDisplayFormName(form.name)),
        App.localize('AreYouSure'),
        (d) => {
          if (d) {
            formTemplateSvc
              .deleteFormTemplate({
                id: form.id,
              })
              .success(() => {
                getAllFormTemplates();
                abp.notify.success(App.localize('SuccessfullyDeleted'));
              });
          }
        }
      );
    }
  }
})();
